<script setup lang="ts">
import type PodcastEpisode from "~~/types/PodcastEpisode";
import { useHelper } from "~/composables/helper";

const { formatDate } = useHelper();

const props = defineProps({
    episode: {
        type: Object as PropType<PodcastEpisode>,
        required: true,
    },
});

const src = computed(() => {
    // Strip 'yt:video:' prefix if it exists
    const videoId = props.episode.id.replace("yt:video:", "");
    return `https://www.youtube.com/embed/${videoId}?si=${videoId}`;
});
</script>

<template>
    <div class="relative mx-auto mb-8 overflow-hidden rounded-xl border p-6 shadow-xl md:flex md:h-72">
        <div class="h-60 flex-none overflow-hidden text-center md:h-full md:w-2/5 md:pr-8">
            <!-- Tried to use the YouTubeEmbed component but it doesn't seem to work -->
            <iframe
                loading="lazy"
                :src="src"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                class="aspect-video w-full"
            ></iframe>
        </div>
        <div class="flex flex-1 flex-col pt-2 md:pt-0">
            <h3 class="mb-2 flex-none text-xl font-bold">
                {{ episode.title }}
            </h3>
            <div class="mb-2 flex-none text-sm text-gray-400 italic">{{ formatDate(episode.published) }}</div>
            <p class="max-h-full flex-1 overflow-y-auto">
                {{ episode.description }}
            </p>
        </div>
    </div>
</template>

<style scoped></style>
